import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button.tsx';
import { Ban, CircleAlert } from 'lucide-react';
import { PanelInfo } from '@/components/custom';
import { LayoutPage } from '@/components/hoc';
import routes from '@/lib/routes';

const NotFoundPage = () => {

  const { pathname } = useLocation();

  return (
    <LayoutPage
      breadcrumb={{}}
      icon={Ban}>
      <PanelInfo
        title='Désolé, page introuvable'
        description={
          <>
            La page que vous essayez de consulter est introuvable.
            <br />
            {pathname}
          </>
        }
        className='py-10 md:py-28 border-none'
        icon={CircleAlert}>
        <Link to={routes.nav.home}>
          <Button
            type='button'
            variant={'secondary'}>
            Retourner à l'accueil
          </Button>
        </Link>
      </PanelInfo>
    </LayoutPage>
  );

};

export default NotFoundPage;
